// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"63c36333","732":"670dd161","977":"647f36cc"}[chunkId] + ".chunk.js";
};